import React, { useState } from 'react';
import { DataTable } from './DataTable';
import { FormDialog } from './FormDialog';
import { ConfirmDialog } from './ConfirmDialog';
import { Button } from './ui/button';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import { apiError } from '../lib/api';

/**
 * Generic CRUD section wired to provided async handlers.
 * props: title, description, rows, columns, fields, canWrite,
 *        onAdd(payload), onUpdate(id, payload), onDelete(id), afterChange(),
 *        addLabel, getRowId, describeRow(row)
 */
export const CrudSection = ({ title, description, rows, columns, fields, canWrite, onAdd, onUpdate, onDelete, afterChange, addLabel = 'Aggiungi', getRowId = (r) => r.id, describeRow, totals = null }) => {
  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [confirm, setConfirm] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const openAdd = () => { setEditing(null); setFormOpen(true); };
  const openEdit = (row) => { setEditing(row); setFormOpen(true); };

  const submit = async (payload) => {
    setSubmitting(true);
    try {
      if (editing) { await onUpdate(getRowId(editing), payload); toast.success('Voce aggiornata'); }
      else { await onAdd(payload); toast.success('Voce aggiunta'); }
      setFormOpen(false);
      await afterChange?.();
    } catch (e) { toast.error(apiError(e, 'Errore nel salvataggio')); throw e; }
    finally { setSubmitting(false); }
  };

  const doDelete = async () => {
    setDeleting(true);
    try { await onDelete(getRowId(confirm)); toast.success('Voce eliminata'); setConfirm(null); await afterChange?.(); }
    catch (e) { toast.error(apiError(e, 'Errore eliminazione')); }
    finally { setDeleting(false); }
  };

  return (
    <div className="space-y-4">
      {(title || canWrite) && (
        <div className="flex items-center justify-between gap-3">
          <div>{title && <h3 className="text-sm font-semibold text-foreground">{title}</h3>}{description && <p className="text-xs text-muted-foreground mt-0.5">{description}</p>}</div>
          {canWrite && onAdd && <Button size="sm" onClick={openAdd} data-testid="data-table-add-button"><Plus className="h-4 w-4 mr-1.5" />{addLabel}</Button>}
        </div>
      )}
      <DataTable columns={columns} rows={rows} getRowId={getRowId} totals={totals}
        actions={{ canWrite, onEdit: onUpdate ? openEdit : undefined, onDelete: onDelete ? (r) => setConfirm(r) : undefined }} />
      <FormDialog open={formOpen} onOpenChange={setFormOpen} title={editing ? 'Modifica voce' : addLabel} fields={fields} initial={editing} onSubmit={submit} submitting={submitting} />
      <ConfirmDialog open={!!confirm} onOpenChange={(o) => !o && setConfirm(null)} title="Confermi l'eliminazione?" description={confirm ? (describeRow ? describeRow(confirm) : 'Questa operazione non può essere annullata.') : ''} onConfirm={doDelete} loading={deleting} />
    </div>
  );
};
